import type { JSONContent, MarkdownRendererHelpers } from '@tiptap/core';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { renderTableToMarkdown, Table, TableKit, type TableOptions } from '@tiptap/extension-table';

function fenceFor(code: string): string {
  const longest = Math.max(0, ...(code.match(/`+/g) ?? []).map((run) => run.length));
  return '`'.repeat(Math.max(3, longest + 1));
}

export const MarkdownCodeBlock = CodeBlockLowlight.extend({
  renderMarkdown(node: JSONContent, h: MarkdownRendererHelpers) {
    const language = (node.attrs?.language as string | null | undefined) ?? '';
    const code = node.content ? h.renderChildren(node.content) : '';
    const fence = fenceFor(code);
    return `${fence}${language}\n${code}\n${fence}`;
  },
});

const MarkdownTable = Table.extend({
  renderMarkdown(node: JSONContent, h: MarkdownRendererHelpers) {
    return renderTableToMarkdown(node, {
      ...h,
      renderChildren: (nodes, separator) => h.renderChildren(nodes, separator).replace(/\|/g, '\\|'),
    });
  },
});

export function markdownTableKit(table: Partial<TableOptions> = {}) {
  return [TableKit.configure({ table: false }), MarkdownTable.configure(table)];
}
